<p style="display: none;">{{title}}</p>
<form role="form" *ngIf="documentForm" [formGroup]="documentForm">

  <div class="row" *ngIf="isLegalPerson==false">
    <div class="col-4">
      <p>Tipo de programa</p>
      <select class="form-select" aria-label="Default select example" formControlName="programTypeId">
        <option *ngFor="let item of programTypes" [value]="item.id">{{ item.description }}</option>
      </select>
    </div>
    <div class="col-4">
      <p>Tipo Titulo</p>
      <select class="form-select" aria-label="Default select example" formControlName="titleTypeId">
        <option *ngFor="let item of titleTypes" [value]="item.id">{{ item.description }}</option>
      </select>
    </div>
    <div class="col-4" *ngIf="documentForm.get('typeProfessionalId').value != null || (documentForm.get('programTypeId').value == '1' || documentForm.get('programTypeId').value == '3')">
      <p>Tipo Profesional</p>
      <select class="form-select" aria-label="Default select example" formControlName="typeProfessionalId">
        <option *ngFor="let item of typeProfessional" [value]="item.id">{{ item.description }}</option>
      </select>
    </div>
  </div>

  <div class="row " *ngIf="isLegalPerson==false">
    <div class="col-sm-12 col-md-6">
      <p>Titulo del programa (como aparece en el diploma) *</p>
      <input formControlName="titleProfessionalName" type="text" name="" id="" class="form-control" />
    </div>
    <div class="col-sm-12 col-md-6" *ngIf="documentForm.get('titleDoctorateName').value != null || documentForm.get('programTypeId').value == '3'">
      <p>Título del postgrado (como aparece en el diploma) *</p>
      <input type="text" formControlName="titleDoctorateName" name="" id="" class="form-control" />
    </div>
    <div class="col-sm-12 col-md-6" *ngIf="documentForm.get('otherProfessionalName').value != null || documentForm.get('typeProfessionalId').value == '4'">
      <p>Otro Tipo profesional</p>
      <input formControlName="otherProfessionalName" type="text" class="form-control" />
    </div>
  </div>

  <div class="row mt-4" *ngIf="isLegalPerson==true">
    <div class="col-8">
      <p>Dirección de la entidad</p>
      <input formControlName="entityAddress" type="text" class="form-control">
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-xs-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <div class="colum_first">
        <table class="table" aria-describedby="mydesc">
          <thead>
            <tr>
              <th scope="col">Descripción</th>
              <th scope="col">Documento</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let document of documentSupports">
              <td>{{document.nameDocument}}</td>
              <td class="d-flex mx-auto">
                <img (click)="visorPdf(document.path)" [src]="urlImageView" class="img-fluid icon" alt="icon">
                <img (click)="downloadPdf(document.path, document.nameDocument)" [src]="urlDowmloadpdf" alt="icon"
                  class="img-fluid icon">
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="col-xs-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
      <div class=" border">
        <div style="display: flex;align-items: center;justify-content: center;">
          <iframe title="iframepdf" width="800" height="500" src="" type="application/pdf"></iframe>
        </div>
      </div>
    </div>
  </div>
</form>
